import { render } from "./RegistrationComponent.vue?vue&type=template&id=4e1381aa&scoped=true"
import script from "./RegistrationComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationComponent.vue?vue&type=script&lang=js"

import "../assets/bootstrap.min.css?vue&type=style&index=0&id=4e1381aa&scoped=true&lang=css"
import "./RegistrationComponent.vue?vue&type=style&index=1&id=4e1381aa&scoped=true&lang=css"
import "./RegistrationComponent.vue?vue&type=style&index=2&id=4e1381aa&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1381aa"]])

export default __exports__